export default {
  SET_INVOICES: function (state, payload) {
    state.invoices = payload;
  }
}
